import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitemapGridComponent } from '../../components/sitemap/sitemap-grid/sitemap-grid.component';

@Component({
  selector: 'app-mapa',
  standalone: true,
  imports: [CommonModule, SitemapGridComponent],
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.scss']
})
export class MapaComponent {
} 